/* eslint-disable @typescript-eslint/strict-boolean-expressions */
declare const YT: unknown; // provided by the Youtube iFrame api https://developers.google.com/youtube/iframe_api_reference

import { enqueueYT } from './embed';
import { getYouTubeID } from './util';
import { EmbedMedia } from './embed_media_abstract';

export class YoutubeEmbed extends EmbedMedia {
    async load(): Promise<this> {
        if (typeof YT !== 'undefined') {
            this.player = await this.build();
        } else {
            await this.api();
            await this.build();
        }
        return this;
    }

    play(): void {
        if (!this.player) {
            return;
        }

        // it's initialized and ready to go
        if (typeof this.player.playVideo === 'function') {
            this.player.playVideo();
            return;
        }

        // or else we need to wait for it to become ready
        this.player.addEventListener('onReady', function(){
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            this.player.playVideo();
        });
    }

    pause(): void {
        if (!this.player) {
            return;
        }

        if (typeof this.player.pauseVideo === 'function') {
            this.player.pauseVideo();
        }
    }

    private getStartTime(url: string): number {
        const match = url.match(/[?&]t=(\d+)/);
        if (match) {
            return parseInt(match[1]);
        }
        return 0;
    }

    private build(): Promise<Object> {
        return new Promise((resolve) => {
            const start = this.getStartTime(this.url);
            const player: Object = new YT.Player(this.placeholder, {
                width: this.element.clientWidth,
                height: Math.round(this.element.clientWidth / 16 * 9),
                videoId: getYouTubeID(this.url),
                playerVars: {
                    autoplay: this.mode === 'autoplay' ? 1 : 0,
                    iv_load_policy: 3,
                    playsinline: 1,
                    disablekb: 1,
                    start
                },
                events: {
                    onReady: (): void => {
                        window.addEventListener('resize', () => {
                            player.setSize(this.element.clientWidth, this.element.clientWidth / 16 * 9);
                        });
                        resolve(player);
                    }
                }
            });
        });
    }

    api(): Promise<void> {
        this.addScript('https://www.youtube.com/iframe_api');
        return new Promise((resolve) => {
            enqueueYT(() => {
                resolve();
            });
        });
    }
}
